import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SchemaService} from "./schema.service";
import {ChooseSchemaComponent} from "./edit-schema/choose-schema.component";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {SharedModule} from "../shared/shared.module";
import {AppTranslateModule} from "../core/translate/translate.module";
import {ConfirmPopoverModule} from "../shared/confirmpopover/confirm.pop.module";
import {SchemaRoutingModule, ROUTED_COMPONENTS} from "./schema.routing.module";
import {SchemaFilterPipe} from "./schema.filter";
import {PreviewPopup} from "./shared/preview-popup";
import {PrettyPrintPipe} from "./shared/jsonformater.pipe";
import {SchemaEditTabs} from "./edit-schema/location/schema-tabs.component";
import {SchemaTab} from "./edit-schema/location/schema-tab";
import {LocationEditComponent} from "./edit-schema/location/location-edit.component";
import {SchemaEditLanding} from "./edit-schema/location/schema-edit-landing.component";
import { SchemaPreviewPopupComponent } from './shared/schema-preview-popup/schema-preview-popup.component';
import { AttributeRowComponent } from './edit-schema/attribute-row/attribute-row.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    AppTranslateModule,
    SharedModule,
    ConfirmPopoverModule,
    SchemaRoutingModule
  ],
  declarations: [
    ROUTED_COMPONENTS,
    SchemaFilterPipe,
    PrettyPrintPipe,
    PreviewPopup,
    SchemaEditLanding,
    SchemaEditTabs,
    SchemaTab,
    LocationEditComponent,
    SchemaPreviewPopupComponent,
    AttributeRowComponent
  ],
  providers: [
    SchemaService
  ],
  exports: [
    ChooseSchemaComponent,
    SchemaFilterPipe,
    PreviewPopup,
    SchemaEditLanding,
    LocationEditComponent
  ]
})
export class SchemaModule { }



// WEBPACK FOOTER //
// ./src/app/schema/schema.module.ts